module.exports = __webpack_public_path__ + "static/media/logoBono.8a9e016f.png";